export default __webpack_public_path__ + "assets/united-arab-emirates-flag.png";